import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import ProductEntry from "../../../components/SummarySubscription/ProductEntry/ProductEntry";
import { getBundleQuantityCount } from "./getBundleQuantityCount/getBundleQuantityCount";
import styles from "./SummarySubscriptionItem.module.scss";
const displaySingleItem = (values) => {
    if (!values) {
        return;
    }
    return (_jsx(_Fragment, { children: values.map((option) => {
            const product_name = "label" in option ? option.label : option.product_name;
            return (_jsxs("li", { className: styles.singleItemList, children: ["\u00B7 ", option.quantity, "x ", product_name] }, option.id));
        }) }));
};
const getQuantityString = (quantity, numberOfPacks, sticksInPack) => {
    return `${quantity * numberOfPacks} packs (${quantity * numberOfPacks * sticksInPack} sticks)`;
};
const SummarySubscriptionItem = ({ id, name, imageUrl, price, quantity, bundle_options, product_type, }) => {
    const numberOfPacks = getBundleQuantityCount(bundle_options, product_type);
    const NUMBER_OF_STICKS_IN_PACK = 20;
    const description = getQuantityString(quantity, numberOfPacks, NUMBER_OF_STICKS_IN_PACK);
    return (_jsx("li", { className: styles.subscriptionProduct, "data-testid": "SummaryCartSubscriptionItem", children: _jsx(ProductEntry, { title: name, description: description, price: price, imageUrl: imageUrl, children: bundle_options && (_jsx("ol", { children: bundle_options?.map(({ values }) => values && displaySingleItem(values)) }, `list-${id}`)) }) }));
};
export default SummarySubscriptionItem;
//# sourceMappingURL=SummarySubscriptionItem.js.map